/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import { pathToFunc } from "./url.js";
/**
 * Production environment
 */
export const ServerProduction = "production";
/**
 * Sandbox environment
 */
export const ServerSandbox = "sandbox";
/**
 * Contains the list of servers available to the SDK
 */
export const ServerList = {
    [ServerProduction]: "https://api.polar.sh",
    [ServerSandbox]: "https://sandbox-api.polar.sh",
};
export function serverURLFromOptions(options) {
    let serverURL = options.serverURL;
    const params = {};
    if (!serverURL) {
        const server = options.server ?? ServerProduction;
        serverURL = ServerList[server] || "";
    }
    const u = pathToFunc(serverURL)(params);
    return new URL(u);
}
export const SDK_METADATA = {
    language: "typescript",
    openapiDocVersion: "0.1.0",
    sdkVersion: "0.29.3",
    genVersion: "2.541.0",
    userAgent: "speakeasy-sdk/typescript 0.29.3 2.541.0 0.1.0 @polar-sh/sdk",
};
//# sourceMappingURL=config.js.map